import styled from 'styled-components';
import baseInputStyle from './baseInputStyle';

const Input = styled.input`
  ${baseInputStyle}
`;

export default Input;
